export enum TenderDecision {
  ACCEPT = 'accept',
  DECLINE = 'decline',
}

export interface ProviderContactOptionVM {
  label: string;
  value: string | undefined;
}
